<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" [ngClass]="{'default': color == 'default','mini-sidebar': showMiniSidebar || role === 5}">
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <app-navigation [companyList]="companyList" class="w-100" [showMiniSidebar]="showMiniSidebar"
    (toggleSidebar)="toggleSidebar()"></app-navigation>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar" *ngIf="role !== 5">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar" [perfectScrollbar]="config">
      <div class="pl-2 pr-2 text-center justify-content-center" *ngIf="!showMiniSidebar">
        <hr class="mt-0" style="width: 100%">
        <div class="logo-container text-center">
          <img id="preview-img" *ngIf="myCompany.logoUrl" class="m-0 m-auto logo-company" [src]="myCompany.logoUrl"
            alt="{{myCompany.name}}" />
        </div>
        <span *ngIf="!myCompany.logoUrl && !showMiniSidebar" class="text-company d-inline-block mt-2">{{myCompany.name}}</span>
        <hr class="mb-0" style="width: 100%">
      </div>
      <app-sidebar (toggleChatBot)="toggleChatBot($event)" [showMiniSidebar]="showMiniSidebar"></app-sidebar>

      <div class="col-12 text-center pb-3 pt-2" *ngIf="!showMiniSidebar">
        <hr>
        <small>
          <a class="text-secondary text-privacy" href="https://trobbit.com/politica-privacidad" target="_blank">
            {{'auth.privacyPolicy' | translate}}</a>
        </small>

        <br><br>

        <small>
          <!-- <span class="text-secondary text-privacy" (click)="openVersionModal()"> -->
          <span class="text-secondary text-privacy">
            {{'auth.appVersion.link' | translate}} {{currentVersion}}</span>
        </small>
      </div>
    </div>

    <!-- End Sidebar scroll-->
  </aside>

  <ng-container *ngIf="role !== 5; else agentWrapper">
    <div class="page-wrapper" [ngClass]="{'conversations-route': isConversationsRoute && isMobile}">
      <div class="container-fluid page-container" [ngClass]="{'conversations-route': isConversationsRoute && isMobile}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-container>

  <ng-template #agentWrapper>
    <div class="page-wrapper agent-wrapper" [ngClass]="{'conversations-route': isConversationsRoute}">
      <div class="container-fluid page-container" [ngClass]="{'conversations-route': isConversationsRoute}">
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-template>

</div>
<!--Chatbox component-->
<app-chat class="bot-open" [enableBot]="chatBotEnabled" [hidden]="!chatBotEnabled"></app-chat>
<!--End chatbox component-->

<!-- Versión modal -->
<ng-template #appVersionModal let-modal>
  <app-version></app-version>
</ng-template>
<!-- End Versión modal -->
